import React, { useState, useEffect } from "react";

import bannerImg from "../../assets/WEBINAR-RPA-banner.jpg";
import realestateImg from "../../assets/realestate.png";

import { FaRobot, FaHome } from "react-icons/fa";

const responsiveStyles = `
  .re-header {
    display: flex;
    height: 110px;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
  }

  .re-header-left {
    flex: 1.5;
    position: relative;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    padding: 0 20px;
  }

  .re-header-overlay {
    position: absolute;
    inset: 0;
    background: rgba(47,183,164,0.7);
  }

  .re-header-badge {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(0,0,0,0.15);
    padding: 14px 22px;
    border-radius: 6px;
    color: #fff;
    width: 520px;
    max-width: 100%;
  }

  .re-header-icon-box {
    width: 36px;
    height: 36px;
    background: #1f7f73;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .re-header-right {
    flex: 1;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    min-width: 0;
  }

  .re-header-right-deco-left {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg,#2fb7a4 30%,#2f6f9f 60%,#2f4a7f);
    clip-path: polygon(0 0, 60% 0, 0 100%);
  }

  .re-header-right-deco-right {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg,#2fb7a4 30%,#2f6f9f 60%,#2f4a7f);
    clip-path: polygon(100% 0, 100% 100%, 40% 100%);
  }

  .re-header-title {
    display: flex;
    align-items: center;
    gap: 12px;
    z-index: 1;
  }

  .re-header-title h2 {
    margin: 0;
    font-size: 30px;
    font-weight: 600;
    color: #243b64;
  }

  .re-main {
    display: flex;
    padding: 60px 80px;
    gap: 60px;
    align-items: flex-start;
  }

  .re-image-wrap {
    flex: 1;
  }

  .re-image-wrap img {
    width: 100%;
    max-width: 650px;
    display: block;
  }

  .re-accordion {
    flex: 1.2;
  }

  .re-accordion-item {
    margin-bottom: 18px;
  }

  .re-accordion-header {
    background: linear-gradient(90deg,#2fb7a4 0%,#2f6f9f 60%,#2f4a7f);
    color: #f4f7fb;
    padding: 8px 24px;
    cursor: pointer;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .re-accordion-arrow {
    font-size: 22px;
    flex-shrink: 0;
    margin-left: 12px;
  }

  .re-accordion-body {
    padding: 20px;
    color: #555;
    line-height: 1.7;
    font-size: 18px;
  }

  /* ── Tablet: 768px – 1024px ── */
  @media (max-width: 1024px) {
    .re-main {
      padding: 40px 40px;
      gap: 40px;
    }

    .re-header-badge {
      width: auto;
      font-size: 14px;
      padding: 10px 16px;
    }

    .re-header-title h2 {
      font-size: 24px;
    }

    .re-accordion-body {
      font-size: 16px;
    }
  }

  /* ── Mobile: ≤ 767px ── */
  @media (max-width: 767px) {
    .re-header {
      flex-direction: column;
      height: auto;
    }

    .re-header-left {
      flex: none;
      padding: 16px;
      min-height: 80px;
    }

    .re-header-badge {
      width: 100%;
      font-size: 13px;
      padding: 10px 14px;
      gap: 8px;
    }

    .re-header-right {
      flex: none;
      padding: 16px;
      min-height: 70px;
    }

    .re-header-right-deco-left,
    .re-header-right-deco-right {
      width: 50px;
    }

    .re-header-title h2 {
      font-size: 20px;
    }

    .re-main {
      flex-direction: column;
      padding: 30px 20px;
      gap: 30px;
    }

    .re-image-wrap {
      width: 100%;
    }

    .re-image-wrap img {
      max-width: 100%;
    }

    .re-accordion {
      width: 100%;
    }

    .re-accordion-header {
      padding: 10px 16px;
      font-size: 14px;
    }

    .re-accordion-body {
      font-size: 15px;
      padding: 16px;
    }
  }

  /* ── Very small phones: ≤ 400px ── */
  @media (max-width: 400px) {
    .re-header-badge {
      font-size: 12px;
      padding: 8px 10px;
    }

    .re-header-title h2 {
      font-size: 17px;
    }

    .re-accordion-header {
      font-size: 13px;
      padding: 8px 12px;
    }

    .re-accordion-body {
      padding: 14px;
      font-size: 13px;
    }
  }
`;

function RealEstatePage() {
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    const styleId = "re-responsive-styles";
    if (!document.getElementById(styleId)) {
      const tag = document.createElement("style");
      tag.id = styleId;
      tag.innerHTML = responsiveStyles;
      document.head.appendChild(tag);
    }
    return () => {
      const existing = document.getElementById(styleId);
      if (existing) existing.remove();
    };
  }, []);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  const data = [
    {
      title: "1.Rent Payment Reminders",
      content:
        "Automated mechanism to check the rent payments pending for the upcoming month, and send auto-reminders to the respective agents to collect the rent amount."
    },
    {
      title: "2.Update Vacant Properties",
      content:
        "Recovers the list of the vacant properties from the business system and update the data in the multiple real estate search websites to increase high visibility."
    },
    {
      title: "3.Remove Sold / Rented Properties",
      content:
        "scrapes the list of the sold-out/rented properties from the business system and update the information in the multiple websites to offer high visibility of the properties to the business."
    },
    {
      title: "4.Manage Vendors",
      content:
        "Auto-update the vendor data collected in an offline mode and maintained in the Excel file"
    },
    {
      title: "5.Updation Of Failed Records",
      content:
        "Auto-update failed records from a batch upload process in the CRM system."
    },
    {
      title: "6.Onboard New Suppliers",
      content:
        "Robot reads the new supplier list maintained and pre-validated in Excel. It then transfers the data in the supplier management system."
    },
    {
      title: "7.Onboard New Properties",
      content:
        "RPA helps to add new properties in the listing by analysing the data from the sheet in the business system."
    }
  ];

  return (
    <div>

      {/* ===== HEADER ===== */}
      <div className="re-header">
        {/* LEFT */}
        <div
          className="re-header-left"
          style={{ backgroundImage: `url(${bannerImg})` }}
        >
          <div className="re-header-overlay" />

          <div className="re-header-badge">
            <div className="re-header-icon-box">
              <FaRobot style={{ color: "#fff", fontSize: "18px" }} />
            </div>

            <span>Robotic process automation - Use Cases</span>

            <span style={{ marginLeft: "auto" }}>›</span>
          </div>
        </div>

        {/* RIGHT */}
        <div className="re-header-right">
          <div className="re-header-right-deco-left" />
          <div className="re-header-right-deco-right" />

          <div className="re-header-title">
            <FaHome style={{ fontSize: "32px", color: "#2fb7a4" }} />

            <h2>Real Estate</h2>
          </div>
        </div>
      </div>

      {/* ===== MAIN SECTION ===== */}
      <div className="re-main">
        {/* IMAGE */}
        <div className="re-image-wrap">
          <img src={realestateImg} alt="Real estate" />
        </div>

        {/* ACCORDION */}
        <div className="re-accordion">
          {data.map((item, i) => (
            <div key={i} className="re-accordion-item">
              <div
                className="re-accordion-header"
                onClick={() => toggle(i)}
              >
                {item.title}
                <span className="re-accordion-arrow">
                  {openIndex === i ? "↑" : "⌄"}
                </span>
              </div>

              {openIndex === i && (
                <div className="re-accordion-body">{item.content}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default RealEstatePage;
